import { Controller } from '@hotwired/stimulus'

// Card disclosure toggle.
//
// Open/closed state lives on the body's `hidden` attribute so no class list has to stay in sync.
// Every change dispatches `beachy-collapse:toggled` so a collapse-all control can follow along.
export default class extends Controller {
  static targets = ['body', 'chevron', 'summary']

  get isOpen() {
    return !this.bodyTarget.hidden
  }

  toggle() {
    this.setOpen(!this.isOpen)
  }

  open() {
    this.setOpen(true)
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    this.bodyTarget.hidden = !open

    if (this.hasSummaryTarget) {
      this.summaryTarget.hidden = open
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.setAttribute('name', open ? 'chevron-down-outline' : 'chevron-forward-outline')
    }

    const toggleButton = this.element.querySelector('[data-action~="beachy-collapse#toggle"]')
    if (toggleButton) toggleButton.setAttribute('aria-expanded', String(open))

    this.dispatch('toggled', { detail: { open } })
  }
}
